var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"选择服务区和时间","custom-class":"c-el-dialog page-system-location-valid","visible":_vm.showDialog,"before-close":_vm._close,"append-to-body":true},on:{"update:visible":function($event){_vm.showDialog=$event}}},[_c('div',{staticClass:"map-container",attrs:{"id":_vm.container}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }